import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Globe,
  MapPin,
  BookOpen,
  X,
  User,
  GraduationCap,
  Microscope,
  Info,
} from "lucide-react";
import mario from "../img/speakers/mario.png";
import mayar from "../img/speakers/mayar.png";
import fidel from "../img/speakers/fidel.png";
import oscar from "../img/speakers/oscar.png";
import gianluca from "../img/speakers/gianluca.jpg";

import cecilia from "../img/speakers/cecilia.png";
import robert from "../img/speakers/roberto.png";
import carlo from "../img/speakers/carlo.png";
import juan from "../img/speakers/juan.jpg";
import maria from "../img/speakers/maria.webp";
import esther from "../img/speakers/esther.jpg";
import elsa from "../img/speakers/elsa.jpg";
import patricia from "../img/speakers/patricia.jpeg";
import juan_manuel from "../img/speakers/juan_manuel.jpeg";
import maria_cristina from "../img/speakers/maria_cristina.png";
import cesar_compadre from "../img/speakers/cesar_compadre.jpeg";
import leticia_cano from "../img/speakers/leticia_cano.jpg";

import andres from "../img/speakers/andres_navarrete.png";
import yes from "../img/speakers/yeyetzib.jpeg";

// Componente para Banderas SVG (Alta Calidad)
const Flag = ({ country, className = "w-6 h-4" }) => {
  const flags = {
    Chile: (
      <svg viewBox="0 0 1500 1000" className={className}>
        <rect width="1500" height="1000" fill="#fff" />
        <rect width="1500" height="500" y="500" fill="#d52b1e" />
        <rect width="500" height="500" fill="#0039a6" />
        <path
          d="M250 101.4l41.5 127.8H425l-108.3 78.7L358.1 436 250 357.3 141.9 436l41.4-128.1L75 229.2h133.5z"
          fill="#fff"
        />
      </svg>
    ),
    Ecuador: (
      <svg viewBox="0 0 144 96" className={className}>
        <rect width="144" height="48" fill="#FFD700" />
        <rect width="144" height="24" y="48" fill="#003594" />
        <rect width="144" height="24" y="72" fill="#CF142B" />
        <circle cx="72" cy="55" r="8" fill="#8B4513" opacity="0.5" />
      </svg>
    ),
    Colombia: (
      <svg viewBox="0 0 3 2" className={className}>
        <rect width="3" height="1" fill="#FCD116" />
        <rect width="3" height="0.5" y="1" fill="#003893" />
        <rect width="3" height="0.5" y="1.5" fill="#CE1126" />
      </svg>
    ),
    México: (
      <svg viewBox="0 0 98 56" className={className}>
        <rect width="32.6" height="56" fill="#006847" />
        <rect width="32.8" height="56" x="32.6" fill="#fff" />
        <rect width="32.6" height="56" x="65.4" fill="#CE1126" />
        <circle cx="49" cy="28" r="4" fill="#654321" opacity="0.4" />
      </svg>
    ),
    Perú: (
      <svg viewBox="0 0 3 2" className={className}>
        <rect width="1" height="2" fill="#D91023" />
        <rect width="1" height="2" x="1" fill="#FFFFFF" />
        <rect width="1" height="2" x="2" fill="#D91023" />
      </svg>
    ),
    Italia: (
      <svg viewBox="0 0 3 2" className={className}>
        <rect width="1" height="2" fill="#009246" />
        <rect width="1" height="2" x="1" fill="#FFFFFF" />
        <rect width="1" height="2" x="2" fill="#CE2B37" />
      </svg>
    ),
    Brasil: (
      <svg viewBox="0 0 1000 700" className={className}>
        <rect width="1000" height="700" fill="#009C3B" />
        <polygon points="500,100 900,350 500,600 100,350" fill="#FFDF00" />
        <circle cx="500" cy="350" r="150" fill="#002776" />
      </svg>
    ),
      Bolivia: (
    <svg viewBox="0 0 3 2" className={className}>
      <rect width="3" height="2" fill="#007934" />
      <rect width="3" height="1.33" fill="#F9E300" />
      <rect width="3" height="0.67" fill="#D52B1E" />
    </svg>
  ),
  USA: (
  <svg viewBox="0 0 190 100" className={className}>
    {/* Fondo de franjas */}
    <rect width="190" height="100" fill="#fff" />

    <rect y="0" width="190" height="7.69" fill="#B22234" />
    <rect y="15.38" width="190" height="7.69" fill="#B22234" />
    <rect y="30.76" width="190" height="7.69" fill="#B22234" />
    <rect y="46.14" width="190" height="7.69" fill="#B22234" />
    <rect y="61.52" width="190" height="7.69" fill="#B22234" />
    <rect y="76.90" width="190" height="7.69" fill="#B22234" />
    <rect y="92.28" width="190" height="7.72" fill="#B22234" />

    {/* Cantón azul */}
    <rect width="76" height="53.85" fill="#3C3B6E" />

    {/* Estrellas */}
    <g fill="#fff">
      <circle cx="7" cy="7" r="1.5" />
      <circle cx="19" cy="7" r="1.5" />
      <circle cx="31" cy="7" r="1.5" />
      <circle cx="43" cy="7" r="1.5" />
      <circle cx="55" cy="7" r="1.5" />
      <circle cx="67" cy="7" r="1.5" />

      <circle cx="13" cy="13" r="1.5" />
      <circle cx="25" cy="13" r="1.5" />
      <circle cx="37" cy="13" r="1.5" />
      <circle cx="49" cy="13" r="1.5" />
      <circle cx="61" cy="13" r="1.5" />

      <circle cx="7" cy="19" r="1.5" />
      <circle cx="19" cy="19" r="1.5" />
      <circle cx="31" cy="19" r="1.5" />
      <circle cx="43" cy="19" r="1.5" />
      <circle cx="55" cy="19" r="1.5" />
      <circle cx="67" cy="19" r="1.5" />

      <circle cx="13" cy="25" r="1.5" />
      <circle cx="25" cy="25" r="1.5" />
      <circle cx="37" cy="25" r="1.5" />
      <circle cx="49" cy="25" r="1.5" />
      <circle cx="61" cy="25" r="1.5" />

      <circle cx="7" cy="31" r="1.5" />
      <circle cx="19" cy="31" r="1.5" />
      <circle cx="31" cy="31" r="1.5" />
      <circle cx="43" cy="31" r="1.5" />
      <circle cx="55" cy="31" r="1.5" />
      <circle cx="67" cy="31" r="1.5" />

      <circle cx="13" cy="37" r="1.5" />
      <circle cx="25" cy="37" r="1.5" />
      <circle cx="37" cy="37" r="1.5" />
      <circle cx="49" cy="37" r="1.5" />
      <circle cx="61" cy="37" r="1.5" />

      <circle cx="7" cy="43" r="1.5" />
      <circle cx="19" cy="43" r="1.5" />
      <circle cx="31" cy="43" r="1.5" />
      <circle cx="43" cy="43" r="1.5" />
      <circle cx="55" cy="43" r="1.5" />
      <circle cx="67" cy="43" r="1.5" />
    </g>
  </svg>
),
  };

  return flags[country] || <Globe size={18} />;
};

const speakersData = [
  {
    id: 1,
    name: "Dr. Mario Simirgiotis Agüero",
    role: "Director del Instituto de Farmacia",
    institution: "Universidad Austral de Chile",
    country: "Chile",
    type: "internacional",
    topic:
      "Estudio metabolómico de líquenes antárticos y frutos endémicos de la selva valdiviana",
    bio: "Mario J. Simirgiotis se graduó en Farmacia en la Universidad de San Luis, Argentina, en 1998, y obtuvo su doctorado en Química de Productos Naturales en 2003. Ha liderado proyectos de alto impacto en farmacognosia y publicado más de 120 artículos científicos.",
    image: mario,
  },
  {
    id: 2,
    name: "Dr. Mayar Luis Ganoza Yupanqui",
    role: "Docente investigador",
    institution: "Universidad Nacional de Trujillo",
    country: "Perú",
    type: "internacional",
    topic:
      "Plantas medicinales endémicas del Perú: etnomedicina, fitoquímica y aplicaciones en el sistema de salud",
    bio: "Docente de la Facultad de Farmacia y Bioquímica de la Universidad Nacional de Trujillo. Químico Farmacéutico de profesión, Maestro en Farmacia y Bioquímica con mención en Productos Naturales Terapéuticos, Doctor en Farmacia y Bioquímica. Calificado como Investigador RENACYT en el nivel II. Coordinador del grupo de investigación COCAPLAMED y miembro de AGRORED NORTE. Autor de 33 publicaciones en Scopus y Web of Science.",
    image: mayar,
  },

  {
    id: 3,
    name: "Dr. Fidel Ángel Torres Guevara",
    role: "Docente investigador",
    institution: "Universidad Católica Sedes Sapientiae Chulucanas",
    country: "Perú",
    type: "internacional",
    topic: "",
    bio: "Doctor en Bioquímica, Magíster en Bioquímica y Biólogo-Botánico. Investigador Principal de AgroRed Norte e investigador del Instituto de Montañas. Miembro del directorio del CITE-CEDEPAS Norte y docente en la Universidad Católica Sedes Sapientiae (Chulucanas, Piura). Ha liderado investigaciones sobre frutales nativos, etnobotánica, fitoquímica y ecofisiología de semillas de papa en el norte del Perú. Ganador de importantes reconocimientos como el Premio Nacional Ambiental Antonio Brack (2014 y 2021) y el Premio MINAM 2011, entre otros.",
    image: fidel,
  },
  {
    id: 4,
    name: "Dr. Robert Osmundo Ybañez Julca",
    role: "Docente Principal y Director del Departamento Académico de Farmacología",
    institution: "Universidad Nacional de Trujillo",
    country: "Perú",
    type: "internacional",
    topic:
      "Actividad espasmolítica de extractos de Juglans neotropica y derivados de fenilaminojuglona: Exploración mecanicística sobre el músculo liso intestinal.",
    bio: "Docente Principal y Director del Departamento Académico de Farmacología, Facultad de Farmacia y Bioquímica de la Universidad Nacional de Trujillo, Perú. Investigador docente calificado por RENACYT (Nivel II). Su labor se centra en el estudio de compuestos naturales con actividad en el sistema nervioso central y músculo liso. Lidera grupos de investigación en la UNT y ha sido director de la Unidad de Investigación de su facultad. Actual presidente de la Sociedad Latinoamericana de Plantas Medicinales y past presidente del XII Congreso Latinoamericano de Plantas Medicinales. Ha publicado numerosos artículos científicos en revistas de alto impacto sobre el efecto de extractos naturales como Mangifera indica, Physalis peruviana, Juglans neotropica, Lepidium meyenii, Vaccinium corymbosum y Valeriana pilosa, abordando el sistema nervioso central, músculo liso y estrés oxidativo. Participó en la elaboración del Formulario Nacional de Medicamentos del Perú y cuenta con amplia experiencia como asesor de tesis de pregrado, especialidad, maestría y doctorado.",
    image: robert,
  },
  {
    id: 5,
    name: "Dr. Carlo Bicchi",
    role: "Full Professor of Pharmaceutical Biology",
    institution: "Università degli Studi di Torino",
    country: "Italia",
    type: "internacional",
    topic:
      "Plant volatiles and separation science: a never-ending story of continuous innovation",
    bio: "Profesor Titular de Biología Farmacéutica en la Universidad de Turín desde 1990. Ha sido Director del Departamento de Scienza e Tecnologia del Farmaco y Decano de la Facultad de Farmacia. Su principal línea de investigación es el desarrollo de tecnologías analíticas para metabolitos especializados bioactivos en matrices vegetales, incluyendo aceites esenciales, terpenoides, compuestos fenólicos y alcaloides, así como el perfilado aromático de cultivos industriales como café, cacao, avellanas, aceite de oliva y té. Sus estudios abarcan preparación de muestras, cromatografía de gases (GC, GC-MS, Fast-GC, MDGC, GCxGC), cromatografía enantioselectiva, cromatografía líquida de alta presión (HPLC, HPLC-MS), extracción con fluidos supercríticos, quimiometría, fingerprinting, metabolómica y sensómica. Cuenta con más de 360 publicaciones científicas en revistas internacionales y más de 400 conferencias plenarias y ponencias. Ha sido editor, editor asociado y miembro de comités científicos de revistas y organizaciones internacionales. Ha recibido importantes reconocimientos internacionales como la Medalla Giovanni Dugo (2018), Medalla Arnaldo Liberti (2019), Medalla COLACRO (2021), Medalla de Honor ISEO (2022) y la Medalla Marcel Golay (2026).",
    image: carlo,
  },
  {
    id: 6,
    name: "Dr. Oscar Sánchez Aguirre",
    role: "Docente investigador",
    institution: "Universidad Veracruzana",
    country: "México",
    type: "internacional",
    topic:
      "Análisis quimiométrico de datos de RMN e identificación de componentes por GC-MS para la detección de compuestos antiproliferativos en células de cáncer de próstata a partir de plantas medicinales de Veracruz",
    bio: "Químico Industrial, Maestro en Química Bioorgánica y Doctor en Ciencias Biomédicas por la Universidad Veracruzana, México. Actualmente se desempeña como profesor en la Facultad de Ciencias Químicas de la Universidad Veracruzana y es miembro del Sistema Nacional de Investigadoras e Investigadores (nivel Candidato) de la Secretaría de Ciencia, Humanidades, Tecnología e Innovación (SECIHTI). Su investigación se centra en el estudio fitoquímico y farmacológico de extractos y aceites esenciales de plantas medicinales de Veracruz con propiedades antiproliferativas, antioxidantes y antimicrobianas. Ha publicado artículos científicos y de divulgación, capítulos de libro y ha participado activamente en congresos y conferencias. Cuenta con experiencia en la dirección de tesis de licenciatura en Química Industrial, Químico Farmacéutico Biólogo y Biología. Es miembro de la Sociedad Latinoamericana de Plantas Medicinales (SOLAPLAMED) y forma parte del comité evaluador del Boletín Latinoamericano de Plantas Medicinales y Aromáticas (BLACPMA). Ha colaborado con instituciones académicas y centros de investigación, incluyendo el Centro de Investigaciones Tropicales, el Instituto de Ciencias de la Salud y el Instituto de Química Aplicada, además de mantener vínculos académicos con la Universidad Técnica Particular de Loja (UTPL, Ecuador).",
    image: oscar,
  },
  {
    id: 7,
    name: "Dr. Gianluca Gilardoni",
    role: "Docente investigador",
    institution: "Universidad Técnica Particular de Loja",
    country: "Ecuador",
    type: "nacional",
    topic:
      "Discovering new natural molecules in essential oils: case studies from Ecuador.",
    bio: "Químico y Doctor en Ciencias Químicas por la Universidad de Pavía, Italia (2006). Ha realizado tres posdoctorados, dos enfocados en el estudio fitoquímico de especies del Kurdistán iraquí y uno como investigador Prometeo en Ecuador. Cuenta con más de 20 años de experiencia en investigación sobre productos naturales, incluyendo aislamiento, elucidación estructural, análisis y síntesis. Posee amplia experiencia en técnicas cromatográficas, espectroscópicas y sensoriales aplicadas a muestras ambientales, farmacéuticas y alimentarias. Es autor de más de 70 publicaciones en revistas internacionales indexadas y múltiples trabajos de divulgación. Ha participado como ponente en congresos y simposios científicos. Desde 2015 es docente en la Universidad Técnica Particular de Loja, donde imparte asignaturas de grado y posgrado en química orgánica y productos naturales. Entre 2017 y 2020 dirigió un grupo de investigación en química medicinal y actualmente integra el comité doctoral del Doctorado en Química de la UTPL y el comité editorial del Journal of Essential Oil Research.",
    image: gianluca,
  },
  {
    id: 8,
    name: "Dra. Cecilia Verónica Núñez",
    role: "Tecnóloga sénior e investigadora",
    institution: "Instituto Nacional de Pesquisas da Amazônia – INPA",
    country: "Brasil",
    type: "internacional",
    topic:
      "Duroia macrophylla - la saga: fitoquímica, cultura de tejidos vegetales y hongos endofíticos para obtener alcaloides y triterpenos antitumorales y antituberculosis.",
    bio: "Licenciada en Química, con maestría y doctorado en Química Orgánica (Productos Naturales), y posdoctorada en Química Orgánica (Productos Naturales) y Farmacognosia por la Université de Lille-2, Francia. Actualmente es tecnóloga sénior en el Instituto Nacional de Pesquisas da Amazônia (INPA) y profesora-asesora en programas de posgrado en Biotecnología (UFAM/INPA, UEA/INPA) y Botánica (INPA). Ha sido becaria de productividad del CNPq (nivel 2) desde 2014. Es editora de revistas científicas como Fitos, Vittalle y Academia Drug Development and Pharmacotherapy, y editora invitada en Microorganisms (MDPI) y Discover Plants (Springer). Su experiencia abarca la química de productos naturales, biotecnología vegetal y fúngica, con énfasis en bioprospección de plantas y hongos endófitos, cultivo de tejidos vegetales, fraccionamiento cromatográfico y evaluación en bioensayos (actividad antimicrobiana, citotóxica, antiangiogénica y antioxidante), así como la elucidación estructural de compuestos y análisis de mezclas mediante RMN.",
    image: cecilia,
  },

  {
    id: 9,
    name: "Dr. Juan Carlos Romero Benavides",
    role: "Director de Maestría en Ciencias Químicas",
    institution: "Universidad Técnica Particular de Loja",
    country: "Ecuador",
    type: "nacional",
    topic:
      "Horchata Lojana: etnomedicina, potencial farmacológico y consumo popular.",
    bio: "Es Doctor en Ciencias Biomédicas por la Universidad Nacional Autónoma de México (UNAM) e Ingeniero Químico con mención Cum Laude por la Escuela Politécnica Nacional del Ecuador. Actualmente, se desempeña como Director de la Maestría en Ciencias Químicas e investigador y docente en la Universidad Técnica Particular de Loja (UTPL). Coordina el grupo de investigación Productos naturales: cáncer y parasitosis, liderando una línea de investigación enfocada en el bioconocimiento para la innovación y el desarrollo. Su trabajo se especializa en la bioquímica de productos naturales y metodologías sintéticas para optimizar fármacos anti-inflamatorios, anticancerosos y antiparasitarios. Ha participado en 35 proyectos de investigación y ha liderado estudios de alto impacto sobre la bebida Horchata, demostrando su citotoxicidad selectiva contra células tumorales y su potencial farmacológico. Es autor de 41 publicaciones en revistas indexadas, un libro, 6 capitulos de libro y ha dictado 60 conferencias a nivel nacional e internacional. Además, es revisor de prestigiosas revistas entre ellas: European Journal of Medicinal Chemistry, Journal of Agriculture and Food Research y Foods.",
    image: juan,
  },

  {
    id: 10,
    name: "Dra.María Elena Cazar Ramírez",
    institution: "Universidad de Cuenca",
    country: "Ecuador",
    type: "nacional",
    topic:"Apósitos nano-estructurados por electrohilado: Incorporación de extractos de Baccharis latifolia y evaluación in vitro para su aplicación en cicatrización cutánea",
    bio: "",
    image: maria,
  },

  {
    id: 11,
    name: "Dra. Esther Ninoska Flores Quisbert",
    institution: "Universidad Mayor de San Andrés",
    country: "Bolivia",
    type: "internacional",
    topic: "El potencial de las plantas medicinales en Bolivia",
     bio:"",
    image: esther,
  },

  {
    id: 12,
    name: "Dra. Elsa Rengifo Salgado",
    institution: "Instituto de Investigaciones de la Amazonia Peruana",
    country: "Perú",
    type: "internacional",
    topic:
      "Convergencia entre el conocimiento tradicional y evidencia científica de especies vegetales medicinales amazónicas de uso compartido en América Latina",
     bio:"",
      image: elsa,
  },

  {
    id: 13,
    name: "Dra. Patricia Landazuri",
    institution: "Universidad del Quindio",
    country: "Colombia",
    type: "internacional",
    topic:
      "Macronutrientes y cáncer: papel de las plantas medicinales en el metabolismo de carbohidratos, lípidos y proteínas.",
     bio:"",
      image: patricia,
  },

  {
    id: 14,
    name: "Dr. Juan Manuel García S",
    institution: "Universidad Técnica Particular de Loja",
    country: "Ecuador",
    type: "nacional",
    topic:
      "Conservar produciendo: gobernanza y valor compartido en las cadenas de palo santo e ishpingo en Ecuador",
    bio:"",
      image: juan_manuel,
  },

  {
    id: 15,
    name: "Abg. María Cristina Puente",
    institution: "BioAmaz",
    country: "Ecuador",
    type: "nacional",
    topic:
      "Desafíos del marco legal ecuatoriano asociados al uso medicinal y comercial de la biodiversidad en Ecuador.",
    bio: "Maria Cristina ha trabajado durante los últimos quince años en proyectos de gobernanza, conservación y desarrollo sostenible, desde el sector social/ privado –organizaciones no gubernamentales-, y estrechamente vinculada con la formulación de políticas públicas, asesoría y acompañamiento a la gestión pública local y nacional. Es miembro de la Comisión de Derecho Ambiental de la UICN, y de la Red Latinoamericana de Derecho Forestal y Ambiental - IUFRO LAC – RELADEFA y de la Sociedad Ecuatoriana de Derecho Forestal y Ambiental SEDEFA.",
    image: maria_cristina,
  },

    {
    id: 16,
    name: " Dr. César Compadre",
    institution: "Tocol Pharmaceuticals LLC",
    country: "USA",
    type: "internacional",
    topic:
      " Tocoflexol: Liberando el potencial terapéutico de la vitamina E",
    bio: "   El Dr. Compadre es Profesor Emérito de la Universidad de Ciencias Médicas de Arkansas, Profesor Honoris Causa de la Universidad Técnica Particular de Loja y Director Científico de Tocol Pharmaceuticals. El Dr. Compadre tiene una amplia experiencia en investigación sobre el desarrollo de compuestos bioactivos basados en compuestos naturales y en el uso de modelos moleculares en el diseño de fármacos y estudios de estructura-actividad. Ha publicado más de 100 artículos y es coautor de más de 70 patentes relacionadas con el desarrollo de compuestos bioactivos. También es el desarrollador de una tecnología antimicrobiana aprobada por la FDA, que se utiliza comercialmente, y cofundador de Tocol Pharmaceuticals, una empresa centrada en el desarrollo de compuestos que protegen de la radiación nuclear y de compuestos anticancerígenos. El Dr. Compadre mantiene amplias colaboraciones internacionales en descubrimiento de fármacos, salud global y fitofármacos. Sus investigaciones en el área del cáncer se enfocan en encontrar nuevos compuestos utilizando una metodología basada en el análisis de las interacciones entre las plantas en su hábitat natural. Esta metodología es rápida, económica y puede implementarse fácilmente en áreas del mundo con alta biodiversidad, aunque tengan menos acceso a instalaciones y ensayos biológicos avanzados",
    image:cesar_compadre
  },

  
    {
    id: 17,
    name: " Dra. Leticia Cano",
    institution: "Universidad Veracruzana",
    country: "México",
    type: "internacional",
    topic:
      "Las plantas medicinales más allá de su uso tradicional",
    bio: " ",
    image:leticia_cano
  },

   
    {
    id: 18,
    name: " Dr. Andrés Navarrete Castro",
    institution: "Universidad Nacional Autónoma de México (UNAM)",
    country: "México",
    type: "internacional",
    topic:
      "Redes farmacológicas, composición química, validación farmacológica y cultivo de tejidos de dos plantas medicinales de México usadas en enfermedades complejas.",
    bio: " ",
    image:andres
  },

   
    {
    id: 19,
    name: "Dra. Yeyetzin Hernández Frías",
    institution: "Farmacopea de los Estados Unidos Mexicanos (FEUM)",
    country: "México",
    type: "internacional",
    topic:
      "Del conocimiento tradicional al estándar farmacopeico: avances y perspectivas de la Farmacopea Herbolaria de los Estados Unidos Mexicano.",
    bio: " ",
    image:yes
  },
];

const SpeakerCard = ({ speaker, onOpenBio }) => {
  return (
    <motion.div
      layoutId={`card-${speaker.id}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      whileHover={{ y: -10 }}
      className="group bg-white rounded-[2rem] overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 flex flex-col h-full"
    >
      <div className="relative w-full h-[240px] overflow-hidden">
        <img
          src={speaker.image}
          alt={speaker.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-60 group-hover:opacity-40 transition-opacity" />

        {/* Badge de País con Bandera */}
        <div className="absolute top-4 left-4 flex items-center gap-2 px-3 py-2 bg-white/95 backdrop-blur-md rounded-2xl shadow-xl">
          <div className="rounded-sm overflow-hidden border border-gray-200">
            <Flag country={speaker.country} />
          </div>
          <span className="text-xs font-black text-gray-800 uppercase tracking-wider">
            {speaker.country}
          </span>
        </div>
      </div>

      <div className="p-6 flex flex-col flex-grow bg-white">
        <div className="mb-4">
          <h3 className="text-xl text-center m-0 font-bold text-gray-900 leading-tight mb-1 group-hover:text-[#459e5a] transition-colors">
            {speaker.name}
          </h3>
          <p className="text-[#459e5a] m-0 p-0 font-semibold text-xs flex items-center gap-1 uppercase tracking-wide">
            <GraduationCap size={14} /> {speaker.institution}
          </p>
        </div>

        <div className="flex-grow bg-gray-50/50 p-4 rounded-2xl  border border-gray-50">
          <p className="text-gray-600 text-sm italic line-clamp-3 leading-relaxed">
            "{speaker.topic}"
          </p>
        </div>

        <button
          onClick={() => onOpenBio(speaker)}
          className="w-full py-4 px-6 bg-gray-900 text-white rounded-2xl font-bold transition-all duration-300 flex items-center justify-center gap-2 hover:bg-[#459e5a] active:scale-95 shadow-lg shadow-gray-200"
        >
          <Info size={18} />
          Conocer Perfil
        </button>
      </div>
    </motion.div>
  );
};

const Modal = ({ speaker, onClose }) => {
  if (!speaker) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 flex items-center justify-center p-4 bg-gray-900/80 backdrop-blur-md "
      onClick={onClose}
      style={{ zIndex: 99 }}
    >
      <motion.div
        initial={{ scale: 0.9, y: 40 }}
        animate={{ scale: 1, y: 0 }}
        exit={{ scale: 0.9, y: 40 }}
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-[2.5rem] w-full max-w-3xl max-h-[90vh] overflow-y-auto relative shadow-2xl"
      >
        <button
          onClick={onClose}
          className="absolute top-6 right-6 p-2 bg-gray-100 hover:bg-red-50 hover:text-red-500 rounded-full transition-all z-10"
        >
          <X size={20} />
        </button>

        <div className="p-10">
          <div className="flex flex-col md:flex-row gap-8 mb-10 border-b border-gray-100 pb-10">
            <div className="w-40 h-40   flex-shrink-0 mx-auto md:mx-0">
              <img
                src={speaker.image}
                alt={speaker.name}
                className="w-full h-full object-cover rounded-3xl shadow-2xl border-4 border-[#459e5a]/10"
              />
            </div>
            <div className="text-center md:text-left flex flex-col justify-center">
              <div className="flex items-center justify-center md:justify-start gap-3 ">
                <div className="w-8 h-5 rounded-sm overflow-hidden shadow-sm border border-gray-100">
                  <Flag country={speaker.country} className="w-full h-full" />
                </div>
                <span className="bg-[#459e5a]/10 text-[#459e5a] px-3 py-1 rounded-full text-[8px] font-black uppercase tracking-[0.2em]">
                  Ponente {speaker.type}
                </span>
              </div>
              <h2 className="text-xl  font-black text-gray-900  leading-tight">
                {speaker.name}
              </h2>
              <p className="text-xs text-gray-500 font-medium ">
                {speaker.role}
              </p>
              <div className="flex items-center justify-center md:justify-start gap-2 text-gray-800">
                <MapPin size={18} className="text-[#459e5a]" />
                <span className="font-bold text-sm">
                  {speaker.institution} — {speaker.country}
                </span>
              </div>
            </div>
          </div>

          <div className="space-y-8">
            <section className="bg-[#459e5a]/5 p-6 rounded-[2rem] border-l-8 border-[#459e5a]">
              <h4 className="flex items-center gap-2 font-bold text-gray-900 mb-0 uppercase text-xs tracking-widest">
                <Microscope size={18} className="text-[#459e5a]" /> Tema de
                Ponencia
              </h4>
              <p className="text-gray-800 font-bold text-s  italic">
                "{speaker.topic}"
              </p>
            </section>

            <section>
              <h4 className="flex items-center gap-2 font-bold text-gray-900 mb-4 uppercase text-xs tracking-widest">
                <User size={18} className="text-[#459e5a]" /> Trayectoria
                Académica
              </h4>
              <div className="text-gray-600 leading-relaxed space-y-4 text-base md:text-lg">
                {speaker.bio.split("\n").map((paragraph, index) => (
                  <p
                    key={index}
                    className="pl-4 text-[#004270] border-l-2 border-gray-100 text-xs"
                  >
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default function App() {
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);

  const internacionales = speakersData.filter(
    (s) => s.type === "internacional",
  );
  const nacionales = speakersData.filter((s) => s.type === "nacional");

  return (
    <div className="min-h-screen bg-white selection:bg-[#459e5a] selection:text-white pb-24">
      {/* Hero Section Simplificado */}
      <div className="relative pt-24 pb-16 px-4 overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(#459e5a10_1px,transparent_1px)] [background-size:20px_20px] -z-10" />

        <div className="max-w-7xl mx-auto text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-3xl font-black text-gray-900 mb-6 tracking-tight"
          >
            Nuestros <span className="text-[#459e5a]">Speakers</span>
          </motion.h1>
          <p className="max-w-2xl mx-auto text-gray-500 text-lg md:text-xl font-medium leading-relaxed">
            Una selección de expertos de{" "}
            <span className="text-gray-900 font-bold underline decoration-[#459e5a] decoration-4">
              Ecuador, Chile, Perú, Italia, México y Brasil
            </span>{" "}
            compartiendo su visión y descubrimientos.
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 space-y-24">
        {/* Internacionales */}
        <section>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12 border-b border-gray-100 pb-8">
            <div className="flex items-center gap-4">
              <div className="p-4 bg-gray-900 text-white rounded-[1.5rem] shadow-2xl">
                <Globe size={28} />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900 uppercase tracking-tighter m-0 p-0">
                  Internacionales
                </h2>
                <p className="text-gray-400 font-bold text-xs uppercase tracking-[0.3em]">
                  Ponentes Magistrales
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            {internacionales.map((speaker) => (
              <SpeakerCard
                key={speaker.id}
                speaker={speaker}
                onOpenBio={setSelectedSpeaker}
              />
            ))}
          </div>
        </section>

        {/* Nacionales */}
        <section>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4  border-b border-gray-100 pb-8">
            <div className="flex items-center gap-4">
              <div className="p-4 bg-[#459e5a] text-white rounded-[1.5rem] shadow-2xl shadow-[#459e5a]/30">
                <MapPin size={28} />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900 uppercase tracking-tighter m-0 p-0">
                  Nacionales
                </h2>
                <p className="text-gray-400 font-bold text-xs uppercase tracking-[0.3em]">
                  Ponentes Magistrales
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 ">
            {nacionales.map((speaker) => (
              <SpeakerCard
                key={speaker.id}
                speaker={speaker}
                onOpenBio={setSelectedSpeaker}
              />
            ))}
          </div>
        </section>
      </div>

      {/* Modal de Biografía */}
      <AnimatePresence>
        {selectedSpeaker && (
          <Modal
            speaker={selectedSpeaker}
            onClose={() => setSelectedSpeaker(null)}
          />
        )}
      </AnimatePresence>

      {/* Footer Decorativo */}
    </div>
  );
}
